//b
import type { AppEnvironment } from './environment.model';
import {
  REPORTING_API_CLOUD_RUN_URL_DEV,
  ReportingApiCloudRunMode,
  ReportingApiTarget,
} from 'ag-common-svc/public-api';

export const environment: AppEnvironment = {
  production: false,
  isPWAEnabled: true,
  useTempMediaUpload: true,
  emulators: {
    functions: {
      enabled: false,
      host: 'localhost',
      port: 4201,
    },
    firestore: {
      enabled: false,
      host: 'localhost',
      port: 8080,
    },
    storage: {
      enabled: false,
      host: 'localhost',
      port: 9199,
    },
  },
  defaultauth: 'firebase',
  firebaseConfig: {
    apiKey: 'AIzaSyBQk0mf1jUDYzgdZrOoKi7TT9cINP-ttn0',
    authDomain: 'alliance-group-portal.firebaseapp.com',
    projectId: 'alliance-group-portal',
    storageBucket: 'alliance-group-portal.appspot.com',
    messagingSenderId: '271585780604',
    appId: '1:271585780604:web:bfa92dc406920565befaf9',
    measurementId: 'G-H76S2T9L7G',
    vapidKey: 'BDYIY4bSKDkveuqzQdsLR7Sj_9OBNM0VTwpW0fHQQNUI2G3bcrpDBx4opKemsymHcq5Dxl1KX5TPHnVZDVVqWrE',
  },
  google: {
    mapsAPIKey: 'AIzaSyCrFVl8PrFGe10YSFCBr9WDBtdEKb1A7LE',
    mapId: '56461284e4d20403',
  },
  portal_url: 'https://dev.alliancegrouplife.com/',
  crm_url: 'https://dev-arm.alliancegrouplife.com/',
  domain: 'dev.alliancegrouplife.com',
  stripe_store_key:
    'pk_live_51Iv0qdAA1F9sT11gZOrl9UWWKBeCSEa510pbjraU8stwK4wdUMkX9kPw72PRPdhd2Ob4J1nYIGSydsf9Vs4nvBUw00O9TgUfUM',
  stripe_payments_public_key_test:
    'pk_test_51MON3hBZ6K5GAvsGVuCE875tXoedNEHv3TKS9okIkxKUDh0ML3iusdx76etQ5G5J3nMbyNQC1M28e8bSBRepNhMs00vcjKL5K2',
  stripe_payments_public_key_live:
    'pk_live_51MON3hBZ6K5GAvsGHsgv4YoNngOOEyIFuoZ1AsXVqTNf2bUkPiThlQ7pV0DF29PnuiBstEr8btccmZnjyQAk4npA00M4BcJ3Xh',
  versionSignal: {
    enabled: true,
    firestoreCollection: 'system',
    firestoreDocumentId: 'ag-portal-version',
    storageKey: 'ag_portal_web_version',
    snoozeStorageKey: 'ag_portal_web_version_snooze_until',
    fallbackPollMs: 1000 * 60,
    afterDeclinePollMs: 1000 * 60,
  },
  version: '1.3.0',
  session_expires: 120,
  user_admin_url: 'https://us-central1-alliance-group-portal.cloudfunctions.net/users',
  reportingApi: {
    target: ReportingApiTarget.CloudRun,
    cloudRun: {
      // Dev always starts from shared Cloud Run and auto-switches to a tagged backend
      // only when the current preview URL contains taskid-* and that tagged backend is healthy.
      url: REPORTING_API_CLOUD_RUN_URL_DEV,
      mode: ReportingApiCloudRunMode.PreviewAuto,
      taskId: null,
    },
  },
};
